import { Component } from '@angular/core';
import {
  DsButtonModule,
  DsFormFieldModule,
  DsLabelModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsToastModel,
  DsToastService,
} from '@bmw-ds/components';
import { FormsModule } from '@angular/forms';
import { StockService } from '../../../services/stock.service';
import { DemoQuoteRequest } from '../../../models/request-quote.model';
import { UserInfoService } from '../../../services/user-info.service';

@Component({
  selector: 'app-show-quote',
  templateUrl: './show-quote.component.html',
  imports: [
    DsModalModule,
    DsFormFieldModule,
    DsLabelModule,
    FormsModule,
    DsButtonModule,
  ],
  styleUrls: ['./show-quote.component.scss'],
})
export class ShowQuoteComponent {
  constructor(
    private stockService: StockService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService,
    private userInfoService: UserInfoService
  ) {}

  demoRequest: DemoQuoteRequest = {
    vin: '',
    userid: '',
    indicator: '',
    customerName: '',
  };
  qouteModalIsOpen: boolean = false;
  demoQuoteResponse = {
    quoteDate: '',
    expiryDate: '',
    customer: '',
    modelDescription: '',
    series: '',
    bodyno: '',
    daysFromRetail: '',
    registrationDate: '',
    mileage: '',
    estimatedPrice: '',
    requestorName: '',
    requestorEmail: '',
    disclaimer: '',
    vin: '',
  };
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };

  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }

  defleetQuote() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Please wait',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.demoRequest = {
      vin: this.demoQuoteResponse.vin.trim(),
      userid: this.userInfoService.getUserId(),
      indicator: 'S',
      customerName: this.demoQuoteResponse.customer.trim(),
    };
    if (!this.demoRequest.vin || !this.demoRequest.userid) {
      this.addToast(
        'critical',
        'Please provide VIN and User ID to fetch the quote.'
      );
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      return;
    }
    this.stockService.defleetQuote(this.demoRequest).subscribe(
      (response) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.qouteModalIsOpen = false;
        if (response.message && response.message.messageText !== '') {
          this.addToast('positive', response.message.messageText);
        } else {
          this.addToast('critical', response.message.messageText);
        }
      },
      (error) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        this.qouteModalIsOpen = false;
        console.error('Error while fetching quote data', error);
        this.addToast(
          'critical',
          'Error while fetching quote data, please try again.'
        );
      }
    );
  }
}
